import _get from 'lodash.get';

export const getOrderSettings = (order) =>
  _get(order, 'company.order_settings', {});
